import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import SalesforceEnv from "./salesforce-env";
import Select from "react-select";
import "./trial-form.css";
import Countries from "../constants/countries";
import {CountryList as countriesWithCode} from "../constants/countries_code";
import region_env from "../constants/region_env";
import ReCAPTCHA from "react-google-recaptcha";
import {Tooltip,IconButton} from "@mui/material"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Stack from '@mui/material/Stack';
import { CAPTCHA_DISABLED_ENVS, SCREEN_MAGIC_EMAIL } from "../constants/common"
import zipy from "zipyai";
import { ZIPPY_ENVS, zipy_sdk_key } from "../utils/common";

const recaptchaRef = React.createRef();

const TrialFormComponent1 = () => {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const formState = location.state;
  const navigate = useNavigate();
  let url_params = "";
  var [fname, setFname] = useState("");
  var [lname, setLname] = useState("");
  var [crm, setCrm] = useState();
  // var [url_params, setURLparams] = useState("");
  var [email, setEmail] = useState("");
  var [company_name, setCompanyName] = useState("");
  var [website, setWebsite] = useState("");
  var [country, setCountry] = useState();
  var [optin, setOptin] = useState();
  const [noOfEmployees,setnoOfEmployees]=useState();
  const [selectedIndustry,setSelectedIndustry]=useState();  
  const [selectedIndustryValue,setSelectedIndustryValue]=useState();  
  const [number_of_employees,setNumberOfEmployees]=useState();
  const [fname_message, setFnameMessage] = useState("");
  const [lname_message, setLnameMessage] = useState("");
  const [email_message, setEmailMessage] = useState("");
  const [company_name_message, setCompanyNameMessage] = useState("");
  const [website_message, setWebsiteMessage] = useState("");
  const [sfNonAdminUserMessage, setsfNonAdminUserMessage] = useState("");
  const [sfUserMessage, setUserNameMessageForSF] = useState("");
  const [phoneNumberMessage, setPhoneNumberMessage] = useState("");
  var [sf_env, setSFEnv] = useState();
  var [is_registered, setRegistrationStatus] = useState(false);
  const [loadingClass, setLoadingClass] = useState("invisible");
  const [disabled, setDisabled] = useState(false);
  const [disableCaptcha, setDisableCaptcha] = useState(false);
  const [capcha, setVerified] = useState(false);
  const [token, setToken] = useState("");
  const [dialCode, setDialCode] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [bottomErrorMessage, setBottomErrorMessage] = useState('');
  const sign_in_url = process.env.REACT_APP_SIGN_IN_URL;
  const faqSalesforceDocCenterurl = "https://www.sms-magic.com/docs/salesforce/faq-category/getting-started/"
  const env = process.env.REACT_APP_ENV;
  var captch_site_key = process.env.REACT_APP_SITE_KEY;
  const options = Countries.country_list;
  const website_regex = /^(https?:\/\/(www\.)?)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\/?$/g
  var utm_campaign = params.get("utm_campaign");
  var utm_medium = params.get("utm_medium");
  var utm_source = params.get("utm_source");
  var [plan_name, setPlanName] = useState("");
  var crmMapIndex;

  var crmMap = {
    "sf": 0,
    "zoho": 1,
    "saas": 2
  }

  const is_captcha_disabled_env = CAPTCHA_DISABLED_ENVS.includes(env);

  const CRM = [
    { label: "Salesforce", value: "sf" },
    { label: "Zoho", value: "zoho" },
    { label: "SMS-Magic Portal", value: "saas" },
  ];

  const EMPLOYEES_NO=[
    {label: "1-10", value: "1 - 10"},
    {label: "11-1K", value: "11-1K"},
    {label: "1K+", value: "1K+"},
  ];

  const INDUSTRY = [
    {label: 'Banking', value: "Banking"},
    {label: 'Education', value: "Education"},
    {label: 'Finance', value: "Finance"},
    {label: 'Healthcare', value: "Healthcare"},
    {label: 'Insurance', value: "Insurance"},
    {label: 'Legal', value: "Legal"},
    {label: 'Recruitment', value: "Recruitment"},
    {label: 'Staffing', value: "Staffing"},
    {label: 'Real Estate', value: "Real Estate"}, 
    {label: 'Technology', value: "Technology"},
    {label: 'Others', value: "Others"},
  ]

  function setFormFields() {
    console.log("formstate: ", formState)
    console.log('params-',params)
    let plan_name = params.get("plan")
    let selected_crm = params.get("crm");
    console.log('plane_name',plan_name)
    console.log("crm --> ", selected_crm);
    if (formState) {
      console.log('status_code', formState.status_code)
      setFname(formState.first_name);
      setLname(formState.last_name);
      setEmail(formState.email_id);
      if (formState.status_code === 409){
        setUserNameMessageForSF(<p>An account already exists with connected Salesforce username. <a className="sing-in-link" href={sign_in_url}>Sign in</a> or use a different Salesforce username.</p>)
        }
      else if(formState.status_code === 403){
        setsfNonAdminUserMessage(<p><a className="sing-in-link" rel="noreferrer" href={faqSalesforceDocCenterurl} target="_blank">Admin rights</a> needed to install/configure SMS Magic Converse App. Connect with user who has admin rights.</p>)
      }
      setSFEnv(formState.org_type);
      setCountry({label: formState.country_name, value: formState.country_code});
      setRegistrationStatus(true);
      setnoOfEmployees({label:formState.number_of_employees,value:formState.number_of_employees});
      setSelectedIndustry({label:formState.industry,value:formState.industry});
      setSelectedIndustryValue(formState.industry);
      setNumberOfEmployees(formState.number_of_employees);
      selected_crm = selected_crm || formState.product_type;
      console.log("selected_crm :: ", selected_crm)
      plan_name = plan_name || formState.plan_name
    }
    setPlanName(plan_name)
    console.log("crmMap[selected_crm] ", selected_crm, crmMap[selected_crm])
    crmMapIndex = crmMap[selected_crm];
    setCrm(CRM[crmMapIndex]);
    console.log("crm_index --> ", crmMapIndex);
    console.log("country: ", country?.label);
  }

  useEffect(() => {
    setFormFields();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (country) => {
    console.log(country)
    setCountry(country);
  };
  const handleToggleChange = (value) => {
    setOptin(!optin);
  };

  const handleCrmChange = (event) => {
    setCrm(event);
    if (event.value !== "sf") {
      setSFEnv("")
    }
  };

  const handleEmployeeChange=(event)=>{
    setnoOfEmployees(event);
    setNumberOfEmployees(event.value);
    console.log(event)
  }

  const handleIndustryChange=(event)=>{
    setSelectedIndustry(event);
    setSelectedIndustryValue(event.value);
  }  

  const get_region_label = () => {
    const region = process.env.REACT_APP_ENV
    // console.log("URL Params ---> ", url_params)
    url_params = "?"+url_params
    const sign_up_link_eu = `http://eu.app.sms-magic.com/trial/${url_params}`
    const sign_up_link_us = `https://app.sms-magic.com/trial/${url_params}`
    const sign_up_link_aus = `https://aus-app.sms-magic.com/trial/${url_params}`

    const labels = {
      production: (<label className="region-label">Your data will be in US data center. You can create account at <a href={sign_up_link_eu}>EU</a> or <a href={sign_up_link_aus}>AUS</a> region.</label>),
      aus_production: (<label className="region-label">Your data will be in AUS data center. You can create account at <a href={sign_up_link_eu}>EU</a> or <a href={sign_up_link_us}>US</a> region.</label>),
      eu_production: (<label className="region-label">Your data will be in EU data center. You can create account at <a href={sign_up_link_aus}>AUS</a> or <a href={sign_up_link_us}>US</a> region.</label>)
    }

    return labels[region]
  }

  const change_region = () => {
    if (region_env.includes(process.env.REACT_APP_ENV)) {
      return (
      <div className="col-sm-12">
        <div className="region-label">
          {get_region_label()}
        </div>
      </div>)
    }
  }

  const validateName = (e) => {
    setFname(e.target.value.trim());
    if (fname.trim().length === 0) {
      setFnameMessage("Please enter first name");
    } else if (!fname.trim().match(/^[\p{L}\p{M}_']+$/u)) {
      setFnameMessage("Use only alphabets, underscore and single quote");
    } else if (fname.trim().length < 2) {
      setFnameMessage("First name is too short");
    } else if (fname.trim().length > 50) {
      setFnameMessage("First name is too long");
    } else {
      setFnameMessage("");
    }
  };

  const validatelName = (e) => {
    setLname(e.target.value.trimStart());
    if (lname.trim().length === 0) {
      setLnameMessage("Please enter last name");
    } else if (!lname.trim().match(/^[\p{L}\p{M}_ ']+$/u)) {
      setLnameMessage("Use only alphabets, underscore and single quote");
    } else if (lname.trim().length < 2) {
      setLnameMessage("Last name is too short");
    } else if (lname.trim().length > 50) {
      setLnameMessage("Last name is too long");
    } else {
      setLnameMessage("");
    }
  };

  const validateDialCode = (e) => {
    if (phoneNumber.length === 0) {
      setPhoneNumberMessage("Please enter phone number");
    }
    else {
      setPhoneNumberMessage("");
    }
  }

  const validatePhone = (e) => {
    if (dialCode.length === 0 && phoneNumber.length === 0){
      setPhoneNumberMessage("Please select dial code and enter phone number");
    }
    else if (dialCode.length === 0 && phoneNumber.length !== 0) {
      setPhoneNumberMessage("Please select dial code");
    }
    else if (phoneNumber.length === 0) {
      setPhoneNumberMessage("Please enter phone number");
    }
    else if (phoneNumber.length > 20) {
      setPhoneNumberMessage("Phone number is too long");
    }
    else if (phoneNumber.length < 4 && phoneNumber.length > 0) {
      setPhoneNumberMessage("Please enter valid phone number");
    }
    else if (dialCode.length === 0 && phoneNumber.length !== 0) {
      setPhoneNumberMessage("Please select dial code");
    }
    else{
      setPhoneNumberMessage("");
    }
    setPhoneNumber(e.target.value);
  }

  const validateEmail = (e) => {
    setRegistrationStatus(false);
    setEmail(e.target.value);
    console.log("env --> ", env);
    let included_envs = ["production", "eu_production", "aus_production"];
    let is_sm_email = email.includes(SCREEN_MAGIC_EMAIL)
    console.log("val-->", included_envs.includes(env));
    if ((included_envs.includes(env) && email.includes("+") && !is_sm_email) || !validator.isEmail(email)) {
      setEmailMessage("Please enter valid email address");
    } else {
      setEmailMessage("");
    }
  };

  const validateCompanyName = (e) => {
    setCompanyName(e.target.value.trimStart());
    if (company_name.trim().length === 0) {
      setCompanyNameMessage("Please enter company name");
    } else if (company_name.trim().length > 50) {
      setCompanyNameMessage("Company name is too long");
    } else if (company_name.trim().length < 2) {
      setCompanyNameMessage("Company name is too short");
    } else {
      setCompanyNameMessage("");
    }
  }

  const validateWebsite = (e) => {
    setWebsite(e.target.value.trimStart());

    if (website.trim().length > 0 && website.trim().length < 5) {
      setWebsiteMessage("Please enter valid website");
    } else if (!website.match(website_regex) && website.trim().length > 0){
      setWebsiteMessage("Please enter valid website");
    }
    else {
      setWebsiteMessage("");
    }
  }

  const checkTestEmail = async (e) => {
    if (email_message.length === 0 && is_captcha_disabled_env) {
      let email_check_url = `${process.env.REACT_APP_BASE_API_URL}/api/v1/trial/user/bypass?email_id=${encodeURIComponent(e.target.value)}`;
      console.log("##check test email");
      let res = await fetch(`${email_check_url}`, {
        method: 'GET',
        headers: {
          "X-ACCESS-TOKEN": process.env.REACT_APP_JWT_TOKEN,
          "CONTENT-TYPE": "application/json",
        },
        credentials: "same-origin",
      });
      let json_res = await res.json();
      if (res.status === 200) {
        console.log("##res json: ", json_res);
        json_res?.is_bypassed === true ? setDisableCaptcha(true) : setDisableCaptcha(false)
      }
    } else {
      setDisableCaptcha(false);
    }
  }

  url_params = (params.toString());
  console.log(`original crm is ${crm?.label}`);
  const handleCaptcha = (value) => {
    console.log("Captcha token--->", value);
    if (value === null) {
      setVerified(false);
    } else {
      setVerified(true);
      setToken(value);
    }
  };

  const isFormValid = () => {
    console.log(`##disbale captcha is-------- ${disableCaptcha}`);
    if (fname && lname && email && country && crm && noOfEmployees && selectedIndustry && optin && !fname_message && !lname_message && !email_message
      && !phoneNumberMessage && !company_name_message && !website_message) {
      if(crm?.value === "sf" && !sf_env) {
        return false
      }
      let is_captcha_disabled = true;
      if (!is_captcha_disabled && !capcha) {
        return false;
      }
      console.log("all fields set");
      return true;
    } else {
      console.debug("all fields not set");
      return false;
    }
  };
   
  // const setCookie = (access_token, refresh_token) => {
  //   document.cookie = "mAgIC_pAnDa=" + access_token + ";path=/";
  //   document.cookie = "mAgIC_r_pAnDa=" + refresh_token + ";path=/";
  //   console.log("cookies ", document.cookie);
  // };

  const handleSaleforceEnv = (event) => {
    console.log("Current Salesforce ENV --> ", event.value)
    setSFEnv(event.value)
  }

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoadingClass("");
      setDisabled(true);
      console.log("calling sms magic api");
      console.log(`plan name is ${plan_name}`);
      console.time("apitime");
      console.log(`token-----> ${token}`);
      
      const api_url = process.env.REACT_APP_TRIAL_API; //'https://dev-app.txtbox.in/api/v1/trial/signup'; //

      const data = {
        first_name: fname.trim(),
        last_name: lname.trim(),
        email_id: email,
        company_name: company_name.trim(),
        website: website.trim(),
        phone_number: dialCode + phoneNumber,
        product_type: crm.value,
        country_name: country.label,
        country_code: country.value,
        plan_name: plan_name,
        number_of_employees: number_of_employees,
        industry: selectedIndustryValue,
        consent: true,
        captcha_response_token: token,
        org_type: sf_env,
        utm_campaign: utm_campaign,
        utm_medium: utm_medium,
        utm_source: utm_source
      }

      let res = await fetch(`${api_url}`, {
        method: "POST",
        headers: {
          "X-ACCESS-TOKEN": process.env.REACT_APP_JWT_TOKEN,
          "CONTENT-TYPE": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify(data),
      });
      let resJson = await res.json();
      console.log("api response::signup", resJson);
      localStorage.setItem("email", email)
      setDisabled(false);
      setLoadingClass("invisible");
      if (res.status === 302) {
        setDisabled(true);
        setLoadingClass("");
        window.location = resJson.url;
        country.label === 'USA' && localStorage.setItem("show10dlcPopup", "true");
      } else if (res.status === 209) {
        navigate('/support')
      }
      else if (res.status === 201) {
        if (ZIPPY_ENVS.includes(process.env.REACT_APP_ENV)) {
          console.log('ZIPPY_ENVS::identify', ZIPPY_ENVS, zipy_sdk_key);
          zipy.identify(email, {
            email: email
          });
        }
        
        setFname("");
        setLname("");
        setCountry("");
        setCrm("");
        setEmail("");
        setSFEnv("");
        setnoOfEmployees("");
        setSelectedIndustry("");
        // setCookie(resJson.access_token, resJson.refresh_token);
        
        localStorage.setItem("stories_delight", resJson.access_token);
        localStorage.setItem("hideBullhorn", "false");
        console.log('country::', country.label)
        country.label === 'USA' && localStorage.setItem("show10dlcPopup", "true");
        navigate("success", { state: { crm_name: crm?.value, plan_name: plan_name } });
      } else if (res.status === 400) {
        setVerified(false);
        recaptchaRef.current.reset();
        if (resJson.message.email_id) {
          setEmailMessage(resJson.message.email_id[0]);
        }

        if (resJson.message.first_name) {
          setFnameMessage(resJson.message.first_name[0]);
        }

        if (resJson.message.last_name) {
          setLnameMessage(resJson.message.last_name[0]);
        }

        if (resJson.message.captcha_response_token) {
          console.log("SOMETHING-WENT-WRONG - Error Status - 400");
          alert("Something went wrong, please try after some time");
        }
        else {
          alert("Something went wrong, please try after some time")
        }
      } else if (res.status === 401) {
        console.log("Authentication error");
        setVerified(false);
        recaptchaRef.current.reset();
        alert("Something went wrong, please try after some time");
      } else if (res.status === 409) {
        if (resJson.exists) {
          if (crm?.value === "saas" || crm?.value === "zoho") {
            if (resJson.navigate_to_resend) {
              let resendcode = resJson.resend_access_code;
              let email_id = email;
              navigate('/verification', { state: { resendAccessCode: resendcode, email_id: email_id } });
              // setTimeout(() => {
              //   console.log("inside navigation to verificaiton")
              //   navigate('/verification', { state: { resendAccessCode: resendcode, email_id: email_id } });
              // }, 5000);
            } else if (resJson.navigate_to_login) {
              setDisabled(true);
              setBottomErrorMessage(resJson.message);
                setTimeout(() => {
                  window.location.href = sign_in_url;
                }, 5000)
            } else {
              setBottomErrorMessage(resJson.error);
            }
          }
        } else {
          console.log("user is already registered else condition - Error Status - 409");
          
          if (crm?.value === "saas" || crm?.value === "zoho") {
            setRegistrationStatus(true);
            setEmailMessage(resJson.message);
          } else {
            if (country.label === 'USA') {
              localStorage.setItem("show10dlcPopup", "true");
            }
            window.location = `/trial/success?register=true`;
          }
        }
        setVerified(false);
        recaptchaRef.current.reset();
      } else {
        console.log("error from api - Error Status: " + res.status);
        alert("Something went wrong, please try after some time");
        setVerified(false);
        recaptchaRef.current.reset();
      }
    } catch (err) {
      console.log("HTTP Error: " + err);
      console.log(err.stack);
      alert("Something went wrong, please try after some time");
      setVerified(false);
      recaptchaRef.current.reset();
    }
  };

  return (
    <div className="sign-up">
      <div className="container-sm">
        <div className="row">{/* Sign In*/}
          <div className="col-12 text-end sign-in-text">
            <span>
              Already have an account? <a className="sing-in-link" href={sign_in_url}>Sign in now</a>
            </span>
          </div>
        </div>
      </div>
      <div className="container mx-auto">
        <div className="row">{/* Logo */}
          <div className="col text-center">
            <a href="/trial" className="magic-logo">
              <img src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg" alt="logo" ></img>
            </a>
            <h2 className="logo-title">Get your free trial account today!</h2>
          </div>
        </div>
        <form id="trialForm">
          <div className="row gy-3">
            {/* First Name & Last Name*/}
            <div className="col-sm-12 col-md-6 position-relative m-b-30">
              <label htmlFor="fname" className="form-label required">First Name</label>
              <input
                type="text"
                id="fname"
                name="fname"
                className="form-control"
                value={fname}
                onSelect={(e) => validateName(e)}
                onChange={(e) => validateName(e)}
                autoComplete="on"
                required
                readOnly={disabled}
              />
              <div className="validation-msg">{fname_message ? <p>{fname_message}</p> : <span>&nbsp;</span>}</div>
            </div>
            <div className="col-sm-12 col-md-6 position-relative m-b-30">
              <label htmlFor="lname" className="form-label required">Last Name</label>
              <input
                type="text"
                id="lname"
                name="lname"
                className="form-control"
                value={lname}
                onSelect={(e) => validatelName(e)}
                onChange={(e) => validatelName(e)}
                autoComplete="on"
                required
                readOnly={disabled}
              />
              <div className="validation-msg">{lname_message ? <p>{lname_message}</p> : <span>&nbsp;</span>}</div>
            </div>
            {/* Business Email*/}
            <div className="col-sm-12 col-md-12 position-relative m-b-30">
              <label htmlFor="email" className="form-label required">Email Address</label>
              <input
                type="text"
                id="email"
                name="email"
                className="form-control"
                value={email}
                onSelect={(e) => validateEmail(e)}
                onChange={(e) => validateEmail(e)}
                onBlur={(e) => checkTestEmail(e)}
                autoComplete="email"
                required="required"
                readOnly={disabled}
              />
              <div className="validation-msg">
                {is_registered || email_message ? null: <span>&nbsp;</span>}
                {email_message ? <p>{email_message}</p> : null}
              </div>
            </div>

            {/* Phone number */}
            <div className="col-sm-12 position-relative m-b-30">
                <label htmlFor="phone" className="form-label mb-1 required">
                      Phone Number
                </label>
                <div className="input-group">
                <Select
                    className="crm-select"
                    options={countriesWithCode}
                    getOptionLabel={(option)=>"("+option.value+") "+option.dialCode}
                    getOptionValue={(option)=>option.dialCode}
                    autosize={true}
                    onChange={(e) => {
                      setDialCode(e.dialCode);
                      validateDialCode(e.value);
                    }}
                    isDisabled={disabled}
                  >
                  </Select>
                  <input
                      type="text"  // Change type to text to handle onKeyDown correctly
                      value={phoneNumber}
                      // onChange={(e) => setPhoneNumber(e.target.value)}
                      onChange={(e) => {
                        validatePhone(e);
                      }}
                      onBlur={(e) => {
                        validatePhone(e);
                      }}
                      onSelect={(e) => {
                        validatePhone(e);
                      }}
                      onFocus={(e) => {
                        validatePhone(e);
                      }}
                      onKeyDown={(e) => {
                        // Prevent entry if the key pressed is not a number
                        if (!/^\d$/.test(e.key) && e.key !== "Backspace" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                          e.preventDefault();
                        }
                      }}
                      className="form-control"
                      placeholder="Phone Number"
                    />
                    </div>
                    <div className="validation-msg">{phoneNumberMessage ? <p>{phoneNumberMessage}</p> : <span>&nbsp;</span>}</div>
            </div>

            {/* Company Name */}
            <div className="col-sm-6 col-md-6 position-relative m-b-30">
              <label htmlFor="company_name" className="form-label required">Company Name</label>
              <input
                type="text"
                id="company_name"
                name="company_name"
                className="form-control"
                value={company_name}
                onSelect={(e) => validateCompanyName(e)}
                onChange={(e) => validateCompanyName(e)}
                onBlur={(e) => validateCompanyName(e)}
                autoComplete="company_name"
                readOnly={disabled}
              />
              <div className="validation-msg">
                {company_name_message ? null: <span>&nbsp;</span>}
                {company_name_message ? <p>{company_name_message}</p> : null}
              </div>
            </div>
            
            {/* website */}
            <div className="col-sm-12 col-md-6 position-relative m-b-30">
              <label htmlFor="website" className="form-label">Website</label>
              <input
                type="text"
                id="website"
                name="website"
                className="form-control"
                value={website}
                onSelect={(e) => validateWebsite(e)}
                onChange={(e) => validateWebsite(e)}
                onBlur={(e) => validateWebsite(e)}
                autoComplete="website"
                readOnly={disabled}
              />
              <div className="validation-msg">
                {website_message ? null: <span>&nbsp;</span>}
                {website_message ? <p>{website_message}</p> : null}
              </div>
            </div>
            
            
            {/* Submit CRM*/}
            <div className="col-sm-12">
              <label htmlFor="CRM" className="form-label required">Select CRM</label>
              <Select
                className="crm-select"
                options={CRM}
                value={crm}
                autosize={true}
                onChange={handleCrmChange}
                isDisabled={disabled}
              ></Select>


              <span>&nbsp;</span>
              <br/>
            </div>
            {/* Submit Salesforce Env */}
            <SalesforceEnv
              crm={crm}
              orgType={sf_env}
              handleSaleforceEnv={handleSaleforceEnv}
              sfUserMessage={sfUserMessage}
              sfNonAdminUserMessage={sfNonAdminUserMessage}
            />
            {/* Select country*/}
            <div className="col-sm-12">
            <Stack direction="row" alignItems="center" >
              <label htmlFor="country" className="form-label required">Select Country</label>
              <Tooltip
              title="Select a destination country where you want to send business messages"
              placement="right" arrow >
                <IconButton>
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              </Stack>
              <Select
                id="country"
                className="crm-select"
                placeholder="Select Destination Country"
                options={options}
                value={country}
                onChange={handleChange}
                autosize={true}
                isDisabled={disabled}
              ></Select>
              <span>&nbsp;</span>
            </div>

            {/* select no_of_employees */}
            <div className="col-sm-12">
            <Stack direction="row" alignItems="center" >
              <label htmlFor="employees" className="form-label required">Select No. Of Employees</label>
              <Tooltip
              title="Select no. of employees in your organisation"
              placement="right" arrow >
                <IconButton>
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Stack>

              <Select
                id="employees"
                className="employee-select"
                options={EMPLOYEES_NO}
                value={noOfEmployees}
                autosize={true}
                onChange={handleEmployeeChange}
                isDisabled={disabled}
              ></Select>
              <span>&nbsp;</span>
            </div>

          {/* select Industry */}
          <div className="col-sm-12">
            <Stack direction="row" alignItems="center" >
              <label htmlFor="employees"  className="form-label required">Select Industry</label>
              <Tooltip
                title="Select your industry"
                placement="right" arrow >
                <IconButton>
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Stack>
              <div data-testid="industry">
              <Select
                id="industry"
                className="employee-select"
                options={INDUSTRY}
                value={selectedIndustry}
                autosize={true}
                onChange={handleIndustryChange}
                isDisabled={disabled}
              ></Select>
              </div>
              <span>&nbsp;</span>
          </div>

            {/* Region Label */}
            {change_region()}
            {/* Consent*/}

            <div className="col-sm-12 ">
              <div className="form-check checkbox-wrap d-flex justify-content-center">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={optin}
                  id="flexCheckDefault"
                  onSelect={handleToggleChange}
                  onChange={handleToggleChange}
                  defaultChecked={false}
                  autoComplete="off"
                  disabled={disabled}
                />

                <label className="form-check-label " htmlFor="flexCheckDefault">
                  By submitting this form, you agree to the <a href="https://www.sms-magic.com/terms-conditions/" target="_blank" rel="noreferrer">Terms of Service</a> &amp; <a href="https://www.sms-magic.com/privacy-policy/" target="_blank" rel="noreferrer">Privacy policy</a>
                </label>

              </div>
            </div>
            {/* reCaptcha*/}
            <div className="col-sm-12 d-flex justify-content-center">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={captch_site_key}
                onChange={handleCaptcha}
                onExpired={() => {
                  recaptchaRef.current.reset();
                }}
              />
            </div>
            {
              bottomErrorMessage && <div className="col-sm-12 d-flex justify-content-center">
                <p className="text-danger" style={{marginBottom : 0, fontSize: 'medium'}}>{bottomErrorMessage}</p>
              </div>
            }
            {/* Submit button*/}
            <div className="col-sm-12 text-center mb-2">
              <button
                className="signup-btn"
                type="submit"
                name="submit"
                disabled={!isFormValid() || disabled}
                onClick={(e) => {handleSubmit(e)}}>
                Start free trial{" "}
                <span className={`spinner-border spinner-border-sm ${loadingClass}`} role="status" aria-hidden="true"/>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TrialFormComponent1;
